import { IP360PartnerFlags } from 'partner360/models/p360PartnerFlags/IP360PartnerFlags'
import { IPartnerWithFlagRequests } from 'partner360/models/partnerFlagRequests/IPartnerWithFlagRequests'

import { getMarketCoverage } from './getMarketCoverage'
import { hasFlag } from './hasFlag'

export const sumMarketCoverage = (
  partners: IPartnerWithFlagRequests[],
  flag: IP360PartnerFlags
) => {
  const values = partners
    .filter((partner) => hasFlag(partner.BitClass, flag.BitValue))
    .map((partner) => getMarketCoverage(partner.Coverage, flag))
    .filter((value): value is number => value !== null)

  if (!values.length) {
    return null
  }

  return values.reduce<number>((sum, value) => sum + value, 0)
}
